import React from 'react';
import PropTypes from 'prop-types';
import { Message } from 'semantic-ui-react';
import './ErrorMessage.scss';

export function getErrorMessage(error) {
  // eslint-disable-next-line no-console
  console.error('Displaying Error', error);
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  if (error.error) {
    return `${error.error}`;
  }
  return 'An unknown error occurred';
}

const ErrorMessage = ({ error }) => (
  <Message negative>
    <Message.Header>{getErrorMessage(error)}</Message.Header>
  </Message>
);

ErrorMessage.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default ErrorMessage;
